import Loader from "../Loader";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { t } from "i18next";
import { Link } from "react-router-dom";
const NoResultFoundModel = ({ moduleName, totalRecords }) => {
    return (
        <div className="noResult">
            <div className="text-center">
                {totalRecords === -1 ? (
                    <h5 className="mt-4">
                        <Loader />

                    </h5>
                ) : moduleName === "cart" ? (
                    <div className="d-flex justify-content-center  vh-10 w-100" style={{ marginBottom: '22px' }}>
                        <div className="text-center">
                            <img
                                src={Batuk}
                                alt="Empty Cart"
                                className="img-fluid mb-3"
                                width={100}
                                height={100}
                                style={{ maxWidth: "400px" }}
                            />
                            <h5 className="fw-bold">{t("Your cart is empty")}</h5>
                            <p className="text-muted">
                                {t("Just relax, let us help you find some first-class products")}
                            </p>
                            <Link to="/my-store">
                                <button
                                    style={{ padding: '5px 16px', fontSize: '14px' }}
                                    className=" Normal-app-btn "
                                >
                                    {t("Add More Products")}{" "}
                                    <i className="fa fa-shopping-cart ms-1"></i>
                                </button>
                            </Link>
                        </div>
                    </div>
                ) : moduleName === "spirituaslGyan" ? (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                        <img
                            src={Batuk}
                            alt="Empty Cart"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "200px" }}
                        />
                        <h5 className="fw-bold text-center">
                            {moduleName === "orderPage" ? t("No orders found for this service.") : t("No blogs available.")}
                        </h5>
                        <p className="text-muted">{t("Please explore our other Services.")}</p>
                    </div>
                ) : (

                    <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                        <img
                            src={Batuk}
                            alt="Empty Cart"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "200px" }}
                        />
                        <h5 className="fw-bold text-center">
                            {moduleName === "orderPage" ? t("No orders found for this service.") : t("No pujas available for this service.")}
                        </h5>
                        <p className="text-muted">{t("Please explore our other Services.")}</p>
                    </div>



                )}
            </div>
        </div>
    );
};
export default NoResultFoundModel;